import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getAllMainFarmsList,
  getAllSubFarmsList,
  updateFarmId,
  updateMainFarmId
} from "../../../modules/farmManagement/action";
import { handleAdminPrefrence } from "../../../modules/user/redux/action";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import Dropdown from "../../FormElement/Dropdown";

const styles = theme => ({
  buttonText: {
    "& fieldset": {
      borderColor: "transparent !important",
      borderBottom: "1px solid #ccc !important",
      borderRadius: "0"
    }
  },
  formControl: {
    minWidth: 200,
    marginRight: 20
  },
  iconDrop: {
    display: "none"
  },
  mainRoot: {
    padding: "5px 14px"
  },
  menuOption: {
    "& a": {
      // color: 'red',
      textDecoration: "underline"
    }
  }
});

class MainFarmDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFarm: this.props.MainFarmId
        ? this.props.MainFarmId
        : DropdownOptions.ALL_MAIN_FARM.id,
      FillingForm: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.FillingForm &&
      nextProps.FillingForm !== this.props.FillingForm
    ) {
      this.setState({ FillingForm: nextProps.FillingForm });
    }
  }
  componentDidMount() {
    if (isSuperAdmin()) {
      this.props.actions.getAllMainFarmsList();
    }
  }

  handleChange = event => {
    const { value } = event.target;
    console.log(value);
    if (value !== "nothing") {
      this.setState({ selectedFarm: value });
      this.props.actions.updateMainFarmId(value);
      this.props.actions.updateFarmId(value);
      if (value !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.actions.getAllSubFarmsList(value);
      }
    }
    if (isSuperAdmin()) {
      localStorage.setItem("farmSwitch", true);
      // localStorage.removeItem("selectedHarvestYear");
      this.props.actions.handleAdminPrefrence();
    }
  };

  render() {
    const {
      classes,
      MainFarmsList = [],
      route: { match }
    } = this.props;
    const { selectedFarm, FillingForm } = this.state;
    const isDisabled =
      match &&
      (match.path === "/app/createticket" ||
        match.path === "/harvestYearList" ||
        match.path === "/app/editTicket" ||
        match.path === "/app/createcontract" ||
        match.path === "/app/editcontract" ||
        match.path === "/settings/users/create" ||
        match.path === "/settings/users/edit" ||
        match.path === "/subFarmsList" ||
        match.path === "/createSubFarm" ||
        match.path === "/farmmanagement/createmainfarm" ||
        match.path === "/farmmanagement/createsubfarm" ||
        match.path === "/farmmanagement/edit" ||
        match.path === "/subFarmsList/edit" ||
        match.path === "/farm-utilities" ||
        match.path === "/farmmanagement/edit" ||
        match.url === "/settings/mandatory-fields/contract" ||
        match.url === "/farmsetup/farminformation/field-groups/create" ||
        match.url === "/farmsetup/farminformation/commodity-varieties/create" ||
        match.url === "/farmsetup/trucklines/create" ||
        match.url === "/farmsetup/destinations/internal/create" ||
        match.url === "/farmsetup/destinations/external/create" ||
        match.url === "/userManagement/edit" ||
        match.url === "/farmsetup/counterparties/create" ||
        match.url === "/usermanagement/changepassword" ||
        match.url === "/changepassword")
        ? true
        : FillingForm;

    const defaultOption = [{ name: "All", id: "ALL_MAIN_FARM" }];
    const farmList = MainFarmsList.map(farm => ({
      name: `${farm.name} [F${farm.id}]`,
      id: farm.id
    }));
    const options = [...defaultOption, ...farmList];

    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <Dropdown
          value={selectedFarm}
          handleChange={this.handleChange}
          disabled={isDisabled}
          isClearable={false}
          options={options}
        />
      </FormControl>
    );
  }
}

MainFarmDropdown.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  return {
    MainFarmsList: state.FarmManagementReducer.MainFarmsList,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    FillingForm: state.FarmManagementReducer.FillingForm
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getAllMainFarmsList,
        getAllSubFarmsList,
        updateMainFarmId,
        updateFarmId,
        handleAdminPrefrence
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MainFarmDropdown));



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/MainFarmDropdown.js